<template>
    <div>
        <PageTitle title="Notificações" />
        <md-list v-if="dadosTimeLine.ok">
            <md-list-item v-for="item in dadosTimeLine.dados.data" :key="item.id">
                <div class="md-text-date">
                    <p>{{item.data}}</p>
                </div>

                <div class="dot"></div>

                <div class="md-text">
                    <span class="md-titulo">{{item.categoria.desc}}</span>
                    <span>{{item.tipo.desc}}</span>
                    <span>{{item.titulo}}</span>
                </div>
            </md-list-item>
        </md-list>

        <div v-else class="md-message">
            <span >{{dadosTimeLine.mensagem}}</span>
        </div>
    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle';
    export default {
        name: 'TimeLine',
        components: {
            PageTitle
        },
        props: {
            dadosTimeLine: {}
        }
    }   
</script>

<style>
    .md-list {
        width: 100%;
        height: 100%;
        max-width: 100%;
        display: inline-block;
        vertical-align: top;
    }

    .md-text-date {
        font-weight: 700;
        font-size: 12px;
        text-align: left;
        margin-right: 20px;
    }

    .md-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        overflow: hidden;
        line-height: 1.25em;
        white-space: nowrap;
        border-left: 5px solid #b1c2d5;
        padding: 20px 0 20px 15px;
        position: relative;
        font-size: 13px;
        height: 100%;
        white-space: pre-wrap;
    }

    .md-titulo {
        font-weight: bold;
        padding: 5px 10px;
        background: rgb(99, 97, 251);
        border-radius: 8px;
        margin-bottom: 8px;
        color: #ffffff;
    }

    .dot {
        display: block;
        position: absolute;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        left: 96px;
        top: 27px;
        background: rgb(99, 97, 251);
        z-index: 9999;
    }

    .md-message {
        text-align: center;
    }
</style>

